import { Component, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1508Model } from './kymw1508.model';
import { KYMW1508InputModel } from './vo/kymw1508-input.model';
import { UpdateCwsIconDataVo } from './vo/update-cws-icon-data.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { UpdateCwsIconData } from './api-services/update-cws-icon-data-service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * アイコン情報編集画面を管理するクラス
 *
 * @export KYMW1508Component
 * @class KYMW1508Component
 */
@Component({
  selector: 'app-kymw1508',
  templateUrl: 'kymw1508.component.html',
  styleUrls: ['kymw1508.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1508Component extends PlessViewHelperSub implements OnInit {

  kymw1508Model: KYMW1508Model = new KYMW1508Model();

  /**
   *Creates an instance of KYMW1508Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1508Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private getCwsIconBaseData: GetCwsIconBaseData,
    private updateCwsIconData: UpdateCwsIconData,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1508Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1508';

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1508Model.updateMarkGroupList(data);

      // CWSアイコン基本情報取得
      this.getCwsIconBaseData.execute({
        iconCode: this.kymw1508Model.iconCode,
      }, (data: any) => {
        if (data === null || data === undefined || Object.keys(data).length === 0) {
          // アイコン情報は存在しません
          this.dialogService.openAlertGetMessage('E0122', ['アイコン情報'], () => {
            this.closeFunction();
          });
        }
        this.kymw1508Model.updateCwsIconBaseData(data);
      });
    });
  }

  /**
   * 画面初期値設定
   *
   * @param vo
   * @memberof KYMW1508Component
   */
  public setInterfaceParam(vo: KYMW1508InputModel) {
    this.kymw1508Model.iconCode = vo.iconCode;
  }

  /**
   * グループコード 値変更
   * 
   * @memberof KYMW1508Component
   */
  public eventIconGroup_CHANGEHandler() {
    if (this.kymw1508Model.iconCode === 'blankVal') this.kymw1508Model.iconCode = '';
  }

  /**
   * 設定 ボタン 押下
   *
   * @memberof KYMW1508Component
   */
  public eventSetting_CLICKHandler() {
    if (PlessViewUtilsSub.isEmpty(this.kymw1508Model.iconName)) {
      this.dialogService.openAlertGetMessage('E0110', ['アイコン名']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1508Model.iconGroup) || this.kymw1508Model.iconGroup === 'blankVal') {
      this.dialogService.openAlertGetMessage('E0103', ['グループ']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1508Model.iconDiv)) {
      this.dialogService.openAlertGetMessage('E0103', ['アイコン区分']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1508Model.arrangeDiv)) {
      this.dialogService.openAlertGetMessage('E0103', ['配置区分']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1508Model.iconExplain)) {
      this.dialogService.openAlertGetMessage('E0110', ['アイコン説明']);
      return;
    }

    this.updateCwsIconData.execute(new UpdateCwsIconDataVo(
      this.kymw1508Model.iconCode,
      this.kymw1508Model.iconName,
      this.kymw1508Model.iconGroup,
      this.kymw1508Model.iconDiv,
      this.kymw1508Model.arrangeDiv,
      this.kymw1508Model.iconExplain,
      this.kymw1508Model.getOutputDiv(),
    ), () => {this.closeFunction()});
  }
}
